import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createStaticVNode as _createStaticVNode, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createStaticVNode("<div class=\"container col-xxl-8 px-4 pt-3\"><div class=\"row flex-lg-row-reverse align-items-center g-5 py-5\"><div class=\"col\"><h1 class=\"display-5 fw-bold lh-1 mb-3\">Contribute to Iceberg</h1><p class=\"lead\"> Interested in contributing to Iceberg? This design system is the result of community contributions, large and small—of code, design, ideas, and guidance. Here’s how you can contribute too! </p></div></div></div><div class=\"container col-xxl-8 px-4\"><div class=\"row flex-lg-row-reverse align-items-center\"><div class=\"col-10 col-sm-8 col-lg-6\"></div><div class=\"col-lg-6\"><h2 class=\"display-5 fw-bold lh-1 mb-3\">Introduction</h2><p class=\"\"> Contributions are not limited to code. We also encourage feedback, documentation and tools.</p><p> All you need is a GitHub account to get started. Most contributions begin with a GitHub issue using one of these templates: <ul><li>Ask a question ( Reach out to the team please!)</li><li>Report a bug ( <a href=\"https://github.com/Tradesolution/iceberg-ui-angular/issues/new?assignees=&amp;labels=bug%2C+needs+triage&amp;template=bug_report.md\">Angular</a> / <a href=\"https://github.com/Tradesolution/iceberg-ui-react/issues/new?assignees=&amp;labels=bug%2C+needs+triage&amp;template=bug-report---.md&amp;title=\">React</a> )</li><li>Request a feature ( <a href=\"https://github.com/Tradesolution/iceberg-ui-angular/issues/new?assignees=&amp;labels=feature+request&amp;template=feature_request.md\">Angular</a> / <a href=\"https://github.com/Tradesolution/iceberg-ui-react/issues/new?assignees=&amp;labels=feature+request&amp;template=feature-request---.md&amp;title=\">React</a> )</li></ul></p></div></div></div>", 2)
const _hoisted_3 = {
  class: "container px-4",
  id: "featured-3"
}
const _hoisted_4 = { class: "row g-4 py-5 row-cols-1 row-cols-lg-3" }
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "feature col" }, [
  /*#__PURE__*/_createVNode("h3", null, "Developers"),
  /*#__PURE__*/_createVNode("p", null, "You can help us build and improve on our components. Reach out to the team and ask what you can help out with!")
], -1)
const _hoisted_6 = { class: "feature col" }
const _hoisted_7 = /*#__PURE__*/_createVNode("h3", null, "Marketing", -1)
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" You can help us expand on our communication style and such! See something missing in our ")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("? Reach out to the ")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("team")
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" and let them know! ")

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _hoisted_1,
    _createVNode("div", _hoisted_3, [
      _createVNode("div", _hoisted_4, [
        _hoisted_5,
        _createVNode("div", _hoisted_6, [
          _hoisted_7,
          _createVNode("p", null, [
            _hoisted_8,
            _createVNode("a", { href: _ctx.ZeroHeightLink }, "styleguide", 8, ["href"]),
            _hoisted_9,
            _createVNode(_component_router_link, { to: "about" }, {
              default: _withCtx(() => [
                _hoisted_10
              ]),
              _: 1
            }),
            _hoisted_11
          ])
        ])
      ])
    ])
  ], 64 /* STABLE_FRAGMENT */))
}